import { MaskedLines, Reveal } from "./Reveal";
import { Overline } from "./SectionHeading";
import { GlowBackground } from "./GlowBackground";

/**
 * PageHeader — interior page hero. Masked-line title + optional lead + children.
 */
export const PageHeader = ({ overline, titleLines = [], lead, children, testid }) => (
  <section
    data-testid={testid}
    className="relative overflow-hidden px-5 pb-14 pt-32 md:px-8 md:pb-20 md:pt-44"
  >
    <GlowBackground />
    <div className="relative mx-auto max-w-5xl">
      {overline && <Reveal><Overline>{overline}</Overline></Reveal>}
      <h1 className="mt-5 font-display text-4xl font-black leading-[0.98] tracking-tight text-ff-ivory sm:text-5xl md:text-6xl">
        <MaskedLines lines={titleLines} />
      </h1>
      {lead && (
        <Reveal delay={0.3} className="mt-7 max-w-2xl">
          <p className="text-base leading-relaxed text-ff-grey md:text-lg">{lead}</p>
        </Reveal>
      )}
      {children && <Reveal delay={0.4} className="mt-9">{children}</Reveal>}
    </div>
  </section>
);

export default PageHeader;
